// Shared app-store constants + platform detection, used by the "Open in app"
// bar/deep-link helper and the settled confirmation's download invite.

export const APP_STORE_URL = "https://apps.apple.com/us/app/vibesplit/id6754899172";

export type Platform = "ios" | "android" | "other";

export function getPlatform(): Platform {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}

// Vibesplit has an iOS app only. Android visitors use the public web page.
export function canOpenNativeApp(): boolean {
  return getPlatform() === "ios";
}

export function getStoreUrl(): string | null {
  return canOpenNativeApp() ? APP_STORE_URL : null;
}

// Safari itself on iOS, as opposed to Chrome, Firefox, Edge and other apps'
// web views there. Only Safari draws Apple's own "Open in the Vibesplit app"
// banner on universal-link paths, and it does so exactly when the app is
// installed, which no web page can find out for itself. Safari sends
// `Version/x … Safari/y`; the other browsers add their own token and in-app
// web views omit `Version/`. Safari View Controller counts as Safari.
export function isIosSafari(): boolean {
  if (getPlatform() !== "ios") return false;
  const ua = navigator.userAgent || "";
  return /Version\/[\d.]+.*Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS|OPT\/|OPiOS|DuckDuckGo|GSA\/|YaBrowser|Brave|Instagram|FBAN|FBAV|Line\//i.test(ua);
}
